import { GalleryConfig } from 'rangeConfig/@types';

const ladmakareGalleryConfig: GalleryConfig = {
  default: [
    {
      sprs: [
        { id: 'SPR-19564688' },
        { id: 'SPR-19564674' },
        { id: 'SPR-39566672' },
        { id: 'SPR-59566671' },
        { id: 'SPR-89564675' },
        { id: 'SPR-59564691' },
        { id: 'SPR-89563992' }
      ]
    }
  ]
};

export default ladmakareGalleryConfig;
